import { useEffect } from "react";

const BASE_TITLE = "Otto Bot";

/**
 * Sets document.title to `Otto Bot` (when context is null/empty) or
 * `Otto Bot: {context}` and restores the previous title on unmount. Pages call
 * this once with a static string (e.g. "Conversations") or with a dynamic
 * value that resolves after data load (e.g. "Conversation (Lyndon Leggate)")
 * - passing null while loading keeps the browser tab on the base title until
 * the real context is known.
 */
export function useDocumentTitle(context: string | null | undefined): void {
  useEffect(() => {
    const previous = document.title;
    const trimmed = typeof context === "string" ? context.trim() : "";
    document.title = trimmed ? `${BASE_TITLE}: ${trimmed}` : BASE_TITLE;
    return () => {
      document.title = previous;
    };
  }, [context]);
}
